// 跨元件的溝通，要先安裝 npm install mitt
import mitt from 'mitt';
const emitter = mitt(); // 啟用
export default emitter; // 匯出
// 接著在最外層(這邊也就是DashBoard.vue)用Provide / Inject
// 最外層import emitter進去，再用Provide讓內層的元件都可以使用外層的功能
// 內層元件用Inject的方式把emitter讀進來